import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import { useTranslation } from 'react-i18next';

import './CardIconAction.scss';

const CardTitleRow = ({ draggable, dragTitle, beforeTitle, children, className = '' }) => {
    const { t } = useTranslation();
    const reorderHint = dragTitle || t('common.drag_to_reorder');

    const DragHandle = SortableHandle(() => (
        <span
            className="CardTitleRow__dragHandle"
            title={reorderHint}
            aria-label={reorderHint}
        >
            <i className="fa fa-arrows" aria-hidden="true" />
        </span>
    ));

    return (
        <div className={`CardTitleRow ${className}`.trim()}>
            {draggable && <DragHandle />}
            {beforeTitle}
            <div className="CardTitleRow__text">{children}</div>
        </div>
    );
};

export default CardTitleRow;
